import * as React from "react";
import { forwardRef } from "react";
const TmSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-5.297-6H8V9.297h2V8H4.5v1.297h2.203zM17.2 16H18.5V8h-1.718l-2.013 5.672h-.039L12.717 8H11v8h1.298v-5.4l1.986 5.322h.933l1.983-5.322z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(TmSVG);
export default ForwardRef;
//# sourceMappingURL=Tm.js.map